module.exports = __webpack_public_path__ + "svg/new-vipps-big.e9fe6caf9cc903171e4b8ba442b42e9b.svg";